export enum ProductionOrderDetailsScreen {
  PART = 'ProductionOrderDetailsPart',
  ORDER = 'ProductionOrderDetailsProductionOrder',
  BATCH = 'ProductionOrderDetailsBatch',
  NC_FILE = 'ProductionOrderDetailsNCFile',
}

export enum ProductionOrderDetailsScreenLink {
  PART = 'part',
  ORDER = 'production-order',
  NC_FILE = 'nc-file',
  BATCH = 'batch',
}

export enum ProductionOrderLevelSubScreen {
  GENERAL = 'General',
  TIMELINE = 'Timeline',
  DOCUMENTS = 'Documents',
}

export enum ProductionOrderLevelSubScreenLink {
  GENERAL = 'general',
  TIMELINE = 'timeline',
  DOCUMENTS = 'documents',
}